export interface AssessmentFormTranslations {
  continueDesc: string;
  continueButton: string;
  completeDesc: string;
  dirty: string;
  errors: {
    accountIdOrDobMissing: string;
  },
}

export const assessmentFormTranslationKeys: AssessmentFormTranslations = {
  continueDesc: 'continueDesc',
  continueButton: 'continueButton',
  completeDesc: 'completeDesc',
  dirty: 'dirty',
  errors: {
    accountIdOrDobMissing: 'errors.accountIdOrDobMissing',
  },
};

export const assessmentFormTranslationsEN: AssessmentFormTranslations = {
  continueDesc: 'Assessment submitted. Continue to the next one.',
  continueButton: 'Continue',
  completeDesc: 'Thank you for completing the assessment. You may now close this window.',
  dirty: 'Are you sure you want to close the form? Incomplete assessments will be lost.',
  errors: {
    accountIdOrDobMissing: 'Account ID or Date of Birth is missing',
  },
};

export const assessmentFormTranslationsES: AssessmentFormTranslations = {
  continueDesc: 'Evaluación enviada. Continúe con la siguiente.',
  continueButton: 'Continuar',
  completeDesc: 'Gracias por completar la evaluación. Ahora puede cerrar esta ventana.',
  dirty: '¿Está seguro de que desea cerrar el formulario? Las evaluaciones incompletas se perderán.',
  errors: {
    accountIdOrDobMissing: 'Falta el ID de cuenta o la fecha de nacimiento',
  },
};
